import { logged_account_id as accountId } from 'state';
import { setLocation } from 'location-helper';
import postLocationData from '../api/post_location_data';

const logOutIfNeeded = (logoutNeed = false) => {
  if (logoutNeed) {
    setLocation('/logout');
  }
};

export const getPosition = (logOutOnReject = true, account = null) => {
  const buildPosition = (position) => ({
    latitude: position.coords.latitude,
    longitude: position.coords.longitude,
  });

  /* added for test purposes - need to be removed before release. */
  if ([668682644, 668682776].indexOf(account) > -1) {
    /* Ontario coords */

    return Promise.resolve(buildPosition({
      coords: {
        latitude: 49.1454879,
        longitude: -81.9102217,
      },
    }));
  }

  if ([668682854, 668682873].indexOf(account) > -1) {
    /* outside of Ontario coords */
    return Promise.resolve(buildPosition({
      coords: {
        latitude: 53.4162096,
        longitude: -94.6536053,
      },
    }));
  }

  return new Promise((resolve, reject) => {
    navigator.geolocation.getCurrentPosition(
      (position) => resolve(buildPosition(position)),
      () => reject(logOutIfNeeded(logOutOnReject)),
    );
  });
};

const positionPost = async () => {
  const res = await postLocationData();
  if (res?.geopositionNeed) {
    const position = await getPosition(true, parseInt(accountId(), 10) || 0);
    const response = await postLocationData({ position });
    logOutIfNeeded(response?.logout);
  }
  logOutIfNeeded(res?.logout);
};

export const locationCheckTimer = () => {
  positionPost();
  setInterval(positionPost, 1000 * 10 * 60 * 30);
};
